export const REACT_APP_PAYPAL_CLIENT_ID = process.env.NODE_ENV === 'production' ? "AR4LqUYRMPODMTgtui-rfiZXfdPTndjrkI3stu4a8OvjiZ-kCAPM_5-XYse3YypExO0OzEpQ9FZ8LDl7" : "ATMV_TZNfhY3zWa2nqwW5f_NX4jHDcNSrkaHjzJ-THe_MzSjxCRcvZllYKPTEWPJktMcPEOHv55v8LZu"
// export const REACT_APP_PAYPAL_CLIENT_ID = "AR4LqUYRMPODMTgtui-rfiZXfdPTndjrkI3stu4a8OvjiZ-kCAPM_5-XYse3YypExO0OzEpQ9FZ8LDl7"

// PEODUCTION KEY : AR4LqUYRMPODMTgtui-rfiZXfdPTndjrkI3stu4a8OvjiZ-kCAPM_5-XYse3YypExO0OzEpQ9FZ8LDl7
// SANDBOX KEY : ATMV_TZNfhY3zWa2nqwW5f_NX4jHDcNSrkaHjzJ-THe_MzSjxCRcvZllYKPTEWPJktMcPEOHv55v8LZu


// SANDBOX TEST USER CREDENTIALS: sb-bqevq21281086@personal.example.com / Test@123